import { OrganizationAction } from "@common/userOrganizationRoles";
import { useCanPerformOrganizationAction } from "./useCanPerformOrganizationAction";

export function useCanManageOrganizationTaskTemplates(): boolean {
    return useCanPerformOrganizationAction(
        OrganizationAction.MANAGE_ORGANIZATION_SETTINGS,
    );
}
